export interface IExperiments {
  [key: string]: 'true' | 'false' | string;
}

export class Experiments {
  constructor(private readonly experiments: IExperiments = {}) {}

  public enabled(specName: string): boolean {
    // eslint-disable-next-line no-prototype-builtins
    const value = this.experiments[specName];
    return value === 'true' || value === 'B';
  }
}
